import { all, put } from "redux-saga/effects";
import AppActions from "bukku/redux/App/actions";
import LoggerActions from "bukku/redux/Logger/actions";
import { AppModalType } from '../../../enums/AppModalType';

/**
 *
 * @param {Object} error - error object from try-catch
 * @param {SagaContext{}} context - contains redux-saga actions and queryParams/requestBody
 * @param {Object} config - contains actionsBlacklist and actionsNoRedispatchList
 *                         * - actionsBlacklist:
 *                               - will NOT show expiry modal,
 *                               - will NOT be logged for redispatch
 *                         * - actionsNoRedispatchList:
 *                               - will show expiry modal,
 *                               - but will NOT be logged for redispatch
 */
export function* error401Handler(
    error,
    context,
    config = {
        actionsBlacklist: [],
        actionsNoRedispatchList: [],
    }) {
    const { statusCode } = error;
    const { actionsBlacklist, actionsNoRedispatchList } = config;

    // message.error(errorMessage);
    if (statusCode === 401 && !actionsBlacklist.includes(context.action?.type)) {
        yield all([
            put({ type: AppActions.APP_STOP_PULLING }),
            put({ type: AppActions.APP_STOP_PUSHING }),
            put({ type: AppActions.OPEN_APP_MODAL, modalType: AppModalType.SESSION_EXPIRED_MODAL }),
        ]);

        if (!actionsNoRedispatchList.includes(context.action?.type)) {
            yield put(
                { type: LoggerActions.LOGGER_ENQUEUE_ACTION_401_QUEUE, action: context.action });
        }
    }
}
